function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8325 1.17882C12.9911 0.940392 13.3375 0.940392 13.496 1.17882L17.5 7.20023C17.679 7.46936 17.4886 7.83178 17.1682 7.83178H15.6651L17.5 10.5913C17.679 10.8604 17.4886 11.2228 17.1682 11.2228H15.6651L17.5 13.9824C17.679 14.2515 17.4886 14.6139 17.1682 14.6139H14.1641V17.987H17.5C17.7761 17.987 18 18.2138 18 18.4935C18 18.7732 17.7761 19 17.5 19H2.5C2.22386 19 2 18.7732 2 18.4935C2 18.2138 2.22386 17.987 2.5 17.987H4.54199V16.0434H2.76898C2.40793 16.0434 2.19335 15.6349 2.39506 15.3316L3.74794 12.7026H2.76898C2.40793 12.7026 2.19335 12.2942 2.39506 11.9908L4.9641 8.12733C5.1428 7.8586 5.53324 7.8586 5.71194 8.12733L8.28098 11.9908C8.48269 12.2942 8.26812 12.7026 7.90706 12.7026H6.9281L8.28098 15.3316C8.48269 15.6349 8.26812 16.0434 7.90706 16.0434H6.13338V17.987H12.1641V14.6139H9.16034C8.84 14.6139 8.64962 14.2515 8.82858 13.9824L10.6635 11.2228H9.16034C8.84 11.2228 8.64962 10.8604 8.82858 10.5913L10.6635 7.83178H9.16034C8.84 7.83178 8.64962 7.46936 8.82858 7.20023L12.8325 1.17882Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPark);
export default __webpack_public_path__ + "static/media/icon-park.3c98b2d326117321605e9da308db4b86.svg";
export { ForwardRef as ReactComponent };